import React from 'react';

const LoadingIcon = ( props )=> <i className='ti ti-shine fa fa-spin' {...props} />;

export default LoadingIcon;


// WEBPACK FOOTER //
// ./src/App/components/LoadingIcon/index.js